import { Copy, ArrowUpRight } from "lucide-react";

export function DuplicateBadge({ count }) {
  if (!count) return null;
  return <span className="mt-1 inline-flex items-center gap-1 rounded-md bg-amber-50 px-1.5 py-0.5 text-xs font-semibold text-amber-800" title="Another accessible lead has the same phone number or email. Open this lead to review.">
    <Copy size={12} aria-hidden="true" /> Possible duplicate · {count}
  </span>;
}

export default function LeadDuplicates({ lead, onOpenLead }) {
  const count = Number(lead?.duplicate_count || 0);
  if (!count) return null;
  const matches = lead.duplicate_matches || [];
  return <section aria-label="Possible duplicate leads" className="rounded-xl border border-amber-200 bg-amber-50/60 p-4">
    <h2 className="flex items-center gap-2 text-sm font-semibold text-amber-950"><Copy size={16} aria-hidden="true" />Possible duplicate · {count} matching {count === 1 ? "lead" : "leads"}</h2>
    <p className="mt-1 text-sm text-amber-900">These accessible records share a phone number or email. They may be separate enquiries—review before taking action. No records have been merged.</p>
    <ul className="mt-3 divide-y divide-amber-100">
      {matches.map(match => <li key={match.id} className="flex flex-wrap items-center justify-between gap-2 py-2">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-slate-800">#{match.id} · {match.name || "Unnamed lead"}</p>
          <p className="text-xs text-slate-600">{match.pipeline_name || "No pipeline"} · {match.same_pipeline ? "Same pipeline" : "Different pipeline"} · Same {(match.matched_on || []).join(" and ")}</p>
        </div>
        {onOpenLead && <button type="button" onClick={() => onOpenLead(match.id)} className="crm-button" aria-label={"Open matching lead " + match.id}>Review<ArrowUpRight size={14} aria-hidden="true" /></button>}
      </li>)}
    </ul>
    {count > matches.length && <p className="mt-2 text-xs text-amber-900">Showing the first {matches.length} of {count} matching leads.</p>}
  </section>;
}
